import { useCallback, useContext } from 'react';
import { useLocation } from '@reach/router';
import GeneralContext from '@/context/GeneralContext';
import { getLanguageFromPath } from '@/utils/localization';

const useInternalLinks = (): ((codename: string) => InternalLinkURL | null) => {
  const { internalLinks } = useContext(GeneralContext);
  const { pathname } = useLocation();
  const currentLanguage = getLanguageFromPath(pathname);

  return useCallback(
    (codename) => internalLinks[currentLanguage]?.[codename] || null,
    [internalLinks, currentLanguage]
  );
};

export default useInternalLinks;
